import React from 'react';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/store-hooks';
import cx from 'classnames';
import FeedbackTable from './FeedbackTable';
import './feedback.css';

const Feedback = () => {
  const { t } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const { isVerticalScreen } = useAppSelector((state) => state.booth);

  return (
    <>
      <div className="feedback-title-container">
        <div className="feedback-title-wrapper text-center whitespace-pre-line">
          <Typography
            variant={TYPOGRAPHY_VARIANTS.H1}
            className="feedback-title"
          >
            {t(`${I18nNamespace.COMMON}:feedbackTitle`)}
          </Typography>
        </div>
        <FeedbackTable isVerticalScreen={isVerticalScreen} />
      </div>
    </>
  );
};

export default Feedback;
